var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcLeaguePointSymbolWhite = function SvgIcLeaguePointSymbolWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    fill: "#F3F5F8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.788 6.395a.59.59 0 0 0-1-.631L4.451 11.05a.59.59 0 0 0 .495.914h3.523l-1.036 1.642a.59.59 0 1 0 .999.631l1.435-2.273h3.348a.59.59 0 0 0 .505-.284l.855-1.354.958-1.517a.59.59 0 0 0-.53-.936h-3.615a.59.59 0 0 0-.519.29l-1.653 2.62H6.017l2.77-4.388Zm1.825 4.387h2.277l.686-1.087.404-.64h-2.276l-1.09 1.727Z",
    fill: "#1C1C1D"
  })));
};
export default SvgIcLeaguePointSymbolWhite;